<template>
  <div class="body">
    <!-- 插画没法替换 -->
    <div class="second_card">
      <img src="~@/views/helpHandbook/images/img2.png" alt="" />
    </div>
    <div class="container_card" v-for="(card, index) in homeData" :key="index">
      <!-- <div class="container_card_top_title_wrapper">
        <i class="left"></i>
        <div class="title">{{ card.title }}</div>
        <i class="right"></i>
      </div> -->
      <!-- 主体 -->
      <div class="container_card_body_wrapper">
        <div
          class="container_card_body_item"
          v-for="(item, index) in card.listData"
          :key="index"
        >
          <div class="wrapper_inner">
            <!-- <img :src="item.icon" alt="" /> -->
            <div class="container_card_body_item_rigth">
              <div style="color: #333333">{{ item.title }}</div>
              <div class="desc">
                {{ item.desc }}
              </div>
              <!-- <div class="line"></div> -->
              <div class="file_list">
                <div
                  v-for="(itemx, index2) in item.fileList"
                  :key="index2"
                  class="file_item"
                >
                  <!-- download -->
                  <a
                    style="color: #006dcc"
                    :href="itemx.url || '#'"
                    target="_blank"
                  >
                    {{ itemx.name }}
                  </a>
                </div>
              </div>
              <div
                class="view_more"
                @click="handleViewMore(item.viewMoreUrl || '#')"
              >
                查看更多
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 帮助手册
 */
export default {
  data() {
    return {
      //阴影图片无法替换
      homeData: [
        {
          listData: [
            {
              title: "了解CloudCC",
              desc: "零门槛上手，快速掌握CloudCC核心亮点与价值",
              fileList: [
                {
                  name: "为什么选择CloudCC",
                  url: "https://cloudcc.cn/whyCloudcc.html",
                },
                {
                  name: "CloudCC能做什么",
                  url: "https://cloudcc.cn/whyCloudcc.html",
                },
                {
                  name: "如何计费",
                  url: "https://cloudcc.cn/sale-cloud/products-salespricing.html",
                },
              ],
              viewMoreUrl: "https://product-help.cloudcc.cn",
            },
            {
              title: "CloudCC产品",
              desc: "销售云、服务云、伙伴云等全系列CRM产品，满足企业多元业务需求",
              fileList: [
                {
                  name: "销售云",
                  url: "https://product-help.cloudcc.cn/product09/",
                },
                {
                  name: "服务云",
                  url: "https://product-help.cloudcc.cn/product01/",
                },
                {
                  name: "伙伴云",
                  url: "https://product-help.cloudcc.cn/product02/",
                },
                {
                  name: "本地部署云",
                  url: "https://product-help.cloudcc.cn/product11/",
                },
              ],
              viewMoreUrl: "https://product-help.cloudcc.cn",
            },
            {
              title: "学习如何使用CloudCC",
              desc: "5分钟上手，轻松配置与使用CloudCC",
              fileList: [
                {
                  name: "如何申请试用？",
                  url: "https://product-help.cloudcc.cn/blog/ru-he-shen-qing-shi-yong/",
                },
                {
                  name: "如何登录？",
                  url: "https://product-help.cloudcc.cn/blog/ru-he-deng-lu/",
                },
                {
                  name: "如何配置自己的应用程序？",
                  url: "https://admin-help.cloudcc.cn/blog/ru-he-pei-zhi-zi-ji-de-ying-yong-cheng-xu/",
                },
                {
                  name: "常见问题",
                  url: "https://admin-help.cloudcc.cn/faq/",
                },
              ],
              viewMoreUrl: "https://admin-help.cloudcc.cn",
            },
            {
              title: "成为CloudCC开发者",
              desc: "掌握CloudCC开发技能，构建个性化企业应用",
              fileList: [
                {
                  name: "什么是CloudCC开发者",
                  url: "https://dev-help.cloudcc.cn/",
                },
                {
                  name: "快速入门",
                  url: "https://dev-help.cloudcc.cn/quick/",
                },
                {
                  name: "实践教程",
                  url: "https://dev-help.cloudcc.cn/practice/",
                },
                {
                  name: "操作指南",
                  url: "https://dev-help.cloudcc.cn/devlearn08/",
                },
              ],
              viewMoreUrl: "https://dev-help.cloudcc.cn",
            },
            {
              title: "黑洞平台",
              desc: "一站式企业级应用集成与扩展平台",
              fileList: [
                {
                  name: "什么是黑洞平台？",
                  url: "https://blackhole-help.cloudcc.cn/",
                },
                {
                  name: "如何加入？",
                  url: "https://blackhole-help.cloudcc.cn/zhu-ce-kai-tong-shang-cheng/",
                },
              ],
              viewMoreUrl: "https://blackhole-help.cloudcc.cn",
            },
            {
              title: "场景案例",
              desc: "典型业务场景落地案例，快速复制成功实践",
              fileList: [
                {
                  name: "销售人员拜访客户进行打卡拍照",
                  url: "https://product-help.cloudcc.cn/product12/xiao-shou-ren-yuan-bai-fang-ke-hu-jin-xing-da-qia-pai-zhao/",
                },
                {
                  name: "企业内部费用报销审批",
                  url: "https://product-help.cloudcc.cn/product12/qi-ye-nei-bu-fei-yong-bao-xiao-shen-pi/",
                },
                {
                  name: "使用合同智能体对合同内容进行智能处理",
                  url: "https://product-help.cloudcc.cn/product12/shi-yong-he-tong-zhi-neng-ti-dui-he-tong-nei-rong-jin-xing-zhi-neng-chu-li/",
                },
              ],
              viewMoreUrl: "https://product-help.cloudcc.cn/",
            },
          ],
        },
      ],
    };
  },
  methods: {
    handleViewMore(url) {
      window.open(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.body {
  min-width: 1366px;
  height: calc(100vh - 60px);
  overflow: auto;
}
.top_card {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px 10%;
  .shaixuan1 {
    width: 183px;
    height: 44px;
  }
  .top_list {
    display: flex;
    justify-content: flex-end;
    > li {
      margin: 0 12px;
      cursor: pointer;
    }
    .home {
      color: #006dcc;
    }
  }
}
.second_card {
  width: 100%;
  > img {
    width: 100%;
    min-width: 1366px;
  }
}
.container_card {
  display: flex;
  padding: 0 20vw;
  flex-direction: column;
  .container_card_top_title_wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 34px;
    > .left {
      width: 120px;
      height: 2px;
      transform: scaleX(-1);
      background-image: linear-gradient(
        234deg,
        rgba(0, 166, 232, 0) 33%,
        #006dcc 100%
      );
    }
    > .title {
      font-size: 28px;
      color: #333333;
      font-weight: 700;
      padding: 0 10px;
    }
    > .right {
      width: 120px;
      height: 2px;
      background-image: linear-gradient(
        234deg,
        rgba(0, 166, 232, 0) 33%,
        #006dcc 100%
      );
    }
  }

  .container_card_body_wrapper {
    display: flex;
    flex-wrap: wrap;
    margin-top: 45px;

    .container_card_body_item {
      display: flex;
      align-items: center;
      width: 33%;
      margin-bottom: 80px;
      justify-content: center;
      flex-direction: row;
      flex-wrap: wrap;
      align-content: flex-start;
      padding: 0 10px; /* 模块之间加间距 */
      .wrapper_inner {
        display: flex;
        width: 100%;
        img {
          width: 110px;
          height: 110px;
          margin-right: 30px;
        }
        .container_card_body_item_rigth {
          width: 100%;
          > div:first-child {
            font-size: 18px;
            font-weight: 600;
          }
          .desc {
            font-size: 14px;
            color: #333;
            font-weight: 400;
            line-height: 20px;
            margin-top: 10px;
            min-height: 46px;
          }
          .line {
            width: 240px;
            height: 1px;
            margin: 8px 0;
            background-image: linear-gradient(
              131deg,
              #dedcda 0%,
              rgba(222, 220, 218, 0) 100%
            );
          }
          .file_list {
            min-height: 110px;
          }
          .file_item {
            margin-top: 8px;
            font-family: SourceHanSansCN-Normal;
            font-size: 14px;
            color: #006dcc;
            letter-spacing: 0;
            font-weight: 400;
          }
          .view_more {
            margin-top: 10px;
            font-size: 14px;
            color: #fff;
            background: #006dcc;
            border-radius: 6px;
            text-align: center;
            padding: 4px 16px;
            cursor: pointer;
            width: 100%;
          }
        }
      }
    }
  }
}
</style>